import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Locations/hooks/useLocationCheckpointScans.ts
function useLocationCheckpointScans(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Locations.GetLocationCheckpointScansList.v2, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useLocationCheckpointScans };

//# sourceMappingURL=useLocationCheckpointScans.js.map